export async function useFetchPasswordResetStart(formData: { email: string }) {
  const route = useRoute()
  const locale = route.params.locale as string

  return await $fetch.raw('/customer/password/reset/start', {
    server: false,
    method: 'POST',
    credentials: 'include',
    baseURL: useRuntimeConfig().public.apiBaseURL,
    body: {
      email: formData.email,
      client: useRuntimeConfig().public.client,
      language: locale,
    },
  })
}
